export default __webpack_public_path__ + "static/intro_bottle_bg-ee7416628a54a0e21b0c44e6326986a1.jpg";